import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
// cSpell:ignore JAAS
/* eslint-disable import/no-unresolved */
import RESTService from '../../api/RESTService';
import SAMLParser from './SAMLParser';
import AuthenticationActions from './actions';
import AuthenticationSelectors from './selectors';
import UserAccountModel from './UserAccountModel';
import ReduxStore from '../Redux/store';
/* eslint-disable import/no-cycle */
import AuthenticationRegistry from './AuthenticationRegistry';
import { sessionStorage } from '../../utils/BrowserStorageUtils';
import EnvUtils from '../../utils/EnvUtils';
import { deprecate } from '../../utils/deprecate';
import SSOAuthentication from './SSOAuthentication';
var Authentication = /*#__PURE__*/_createClass(function Authentication() {
  _classCallCheck(this, Authentication);
});
/**
 * Returns instance of SAML Parser.
 * @param {Object} response The HTTP response.
 */
_defineProperty(Authentication, "getSAMLParser", function (response) {
  return new SAMLParser(response.text);
});
_defineProperty(Authentication, "isSSOEnabled", function () {
  return EnvUtils.getEnvironmentProperty('REACT_APP_SAMLSSO_ENABLED');
});
_defineProperty(Authentication, "isDevAuthEnabled", function () {
  return EnvUtils.getEnvironmentProperty('REACT_APP_AUTH_METHOD') === 'DevAuthentication';
});
// Is SP-initiated the type of SSO configured. The main types are IDP (Identity Provided, if false) or SP (Service Provider).
_defineProperty(Authentication, "isSSOTypeSP", function () {
  return EnvUtils.getEnvironmentProperty('REACT_APP_SAMLSSO_SP_MODE');
});
// Get the API URL by appending the target REST Endpoint to the base API URL.
_defineProperty(Authentication, "getApiUrl", function (restEndpoint) {
  var _context;
  return _concatInstanceProperty(_context = "".concat(process.env.REACT_APP_REST_URL, "/")).call(_context, restEndpoint);
});
_defineProperty(Authentication, "getIDPSSOLogoutUrl", function () {
  return EnvUtils.getEnvironmentProperty('REACT_APP_SAMLSSO_USERLOGOUT_URL', '');
});
_defineProperty(Authentication, "getACSUrl", function () {
  return EnvUtils.getEnvironmentProperty('REACT_APP_SAMLSSO_SP_ACS_URL', '');
});
_defineProperty(Authentication, "getSPSSOUrl", function () {
  return EnvUtils.getEnvironmentProperty('REACT_APP_SAMLSSO_IDP_SSOLOGIN_URL', '');
});
/**
 * @deprecated This function is no longer used internally and has been replaced with composable functions exposed in SSOAuthentication and used in the SSOVerifier component. Please refer to these to achieve the same outcome. This will be removed in the next major release
 * @see SSOAuthentication
 * @see SSOVerifier
 *
 *  Performs SP initiated SSO authentication request. When the request is
 *  successful login page is displayed for the user to enter the credentials.
 *
 * @param {function} callbackAfterInitialSuccess
 * @param {function} callbackSSOVerifier
 */
_defineProperty(Authentication, "callbackAfterAuthRequest", deprecate(function (callbackAfterInitialSuccess, callbackSSOVerifier) {
  return Authentication.UNSAFE_callbackAfterAuthRequest(callbackAfterInitialSuccess, callbackSSOVerifier);
}, 'callbackAfterAuthRequest() is deprecated and will be removed. See JSDoc'));
/**
 * @deprecated
 * @see Authentication.callbackAfterAuthRequest
 */
// eslint-disable-next-line camelcase
_defineProperty(Authentication, "UNSAFE_callbackAfterAuthRequest", function (callbackAfterInitialSuccess, callbackSSOVerifier) {
  return function (success, response) {
    if (success === true) {
      if (response != null) {
        var samlParser = Authentication.getSAMLParser(response);
        // Fetching the SAML response key from the SSO response.
        var samlResponseKey = samlParser.getSAMLResponseKey();
        var SAMLTokenVal = samlParser.getToken();
        if (SAMLTokenVal != null) {
          ReduxStore.internalStore.dispatch(AuthenticationActions.setSSOToken(SAMLTokenVal));
        }
        // For users who logged into SSO and not logged into SPM,
        // SAML response key is returned by the SSO which can before
        // used to authenticate to SPM
        if (samlResponseKey != null) {
          callbackAfterInitialSuccess(true, response);
        } else {
          // When users do not have the SAML response key a callback
          // is needed to inform SSOVerifier that user is not logged in.
          callbackSSOVerifier();
        }
      }
    } else {
      // Problem with SSO authentication
      callbackSSOVerifier();
    }
  };
});
/**
 * @deprecated This function is no longer used internally and has been replaced with composable functions exposed in SSOAuthentication and used in the SSOVerifier component. Please refer to these to achieve the same outcome. This will be removed in the next major release
 * @see SSOAuthentication
 * @see SSOVerifier
 *
 * Performs SP initiated SSO authentication request. When the request is
 * successful login page is displayed for the user to enter the credentials.
 *
 * @param {httpResponse} HTTP response that contains SAML request key and Relay state.
 *
 */
_defineProperty(Authentication, "performSPInitSSOAuthRequest", deprecate(function (httpResponse, callbackAfterInitialSuccess, callbackSSOVerifier) {
  return Authentication.UNSAFE_performSPInitSSOAuthRequest(httpResponse, callbackAfterInitialSuccess, callbackSSOVerifier);
}, 'performSPInitSSOAuthRequest() is deprecated and will be removed. See JSDoc'));
/**
 * @deprecated
 * @see Authentication.performSPInitSSOAuthRequest
 */
// eslint-disable-next-line camelcase
_defineProperty(Authentication, "UNSAFE_performSPInitSSOAuthRequest", function (httpResponse, callbackAfterInitialSuccess, callbackSSOVerifier) {
  if (httpResponse !== null) {
    var samlParser = new SAMLParser(httpResponse.text);
    // Fetching the SAML request key from the AuthRequest of SP
    var samlRequest = samlParser.getSAMLRequestKey();
    var samlRelayState = samlParser.getRelayState();
    if (samlRequest === null) {
      // Problem with SP if the AuthReqest is not generated.
      // This needs to be pushed to exception handler properly.
      callbackSSOVerifier();
    } else {
      var initData = {
        RelayState: samlRelayState,
        SAMLRequest: samlRequest
      };
      RESTService.post(Authentication.getSPSSOUrl(), initData, function (success, response) {
        Authentication.callbackAfterAuthRequest(callbackAfterInitialSuccess, callbackSSOVerifier)(success, response);
      }, 'form', true);
    }
  }
});
/**
 * Logs the user in, using the username and password provided. This is a post request to the
 * server to authenticate the user. Also makes a call to get the user type. This is a get request
 * to the server.
 *
 * Once both requests have finished the callback function will be called.
 *
 * @param {string} username the username
 * @param {string} password the password
 * @param {function} callback a callback function that is run after the login returns
 * @param {Boolean} ssoPreCheck flag to denote if SSO authentication pre-check is being performed.
 * @param {Boolean} ssoLogin flag to denote if SSO authentication is being performed.This property
 * is set in .env.
 * This check is performed when loading the login page to check if the user has already been
 * logged in SSO externally.
 */
_defineProperty(Authentication, "login", function (username, password, callback) {
  var ssoPreCheck = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var ssoLogin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Authentication.isSSOEnabled();
  AuthenticationRegistry.authenticationType.login({
    username: username,
    password: password,
    callback: callback,
    ssoPreCheck: ssoPreCheck,
    ssoLogin: ssoLogin
  });
});
/**
 * Logs the current user out.
 * This kills the server session associated with the current window, as well
 * as clearing the sessionStorage for the current window.
 *
 * @param {function} callback a function that will be invoked on completion.
 * The callback function will be passed a boolean indicating success and an
 * object representing the response.
 */
_defineProperty(Authentication, "logout", function () {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var reportLogoutError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (callback && typeof callback !== 'function') {
    throw new Error('The callback argument must be of type function');
  }
  AuthenticationRegistry.authenticationType.logout(callback, reportLogoutError);
});
_defineProperty(Authentication, "clearSessionStorage", function () {
  sessionStorage.removeItem('username');
  sessionStorage.removeItem('user_account');
});
_defineProperty(Authentication, "clearCookiesFromStorage", function () {
  // cSpell:ignore JSESSIONID
  var jSessionIdCookieName = 'JSESSIONID';
  document.cookie = "".concat(jSessionIdCookieName, "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
  // cSpell:ignore Ltpa
  var lpaToken2CookieName = 'LtpaToken2';
  document.cookie = "".concat(lpaToken2CookieName, "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
});
/**
 * Returns the logged in user.
 *
 * @param {*} state the state can be passed in, or else defaults to
 * the global store using the ReduxStore handle if the calling function does not
 * have a handle on state.
 *
 * @returns {string} the user id of the logged in user.
 */
_defineProperty(Authentication, "getLoggedInUser", function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ReduxStore.internalStore.getState();
  return AuthenticationSelectors.getLoggedInUser(state);
});
/**
 * @deprecated This function has been moved to SSOAuthentication.getSSOToken. Please change any dependency to reference the new function. This will be removed in the next major release
 * @see SSOAuthentication.getSSOToken
 *
 * Returns the SSO token.
 *
 * @param {*} state the state can be passed in, or else defaults to
 * the global store using the ReduxStore handle if the calling function does not
 * have a handle on state.
 *
 * @returns {string} the SSO token.
 */
_defineProperty(Authentication, "getSSOToken", deprecate(function (state) {
  return Authentication.UNSAFE_getSSOToken(state);
}, 'getSSOToken() is deprecated and will be removed. See SSOAuthentication.getSSOToken instead'));
/**
 * @deprecated
 * @see Authentication.getSSOToken
 */
// eslint-disable-next-line camelcase
_defineProperty(Authentication, "UNSAFE_getSSOToken", function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ReduxStore.internalStore.getState();
  return SSOAuthentication.getSSOToken(state);
});
/**
 * Gets the current user account.
 * The user account provides the last logged in time, and the user type.
 *
 * @param {*} state the state can be passed in, or else defaults to
 * the global store using the ReduxStore handle if the calling function does not
 * have a handle on state.
 *
 * @returns the user account details.
 */
_defineProperty(Authentication, "getUserAccount", function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ReduxStore.internalStore.getState();
  var userAccount = AuthenticationSelectors.getUserAccount(state);
  return new UserAccountModel(userAccount);
});
/**
 * Checks if the current user type is one of 'userTypes'.
 *
 * @param {Array} userTypes an array of user types to compare the current user type against. Should
 * be populated with values from Authentication.USER_TYPES only.
 *
 * @returns true if the current user type is included in 'userTypes', false otherwise
 */
_defineProperty(Authentication, "userTypeIs", function (userTypes) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ReduxStore.internalStore.getState();
  var userAccount = AuthenticationSelectors.getUserAccount(state);
  var model = new UserAccountModel(userAccount);
  return _includesInstanceProperty(userTypes).call(userTypes, model.userType);
});
/**
 * Authenticate the current user as public citizen in order to be able to
 * access a restricted set of the SPM APIs.
 *
 * @param {function} callback a callback function that will be invoked
 * after authenticating the user. The function will receive a boolean indicating
 * success and and the response object.
 */
_defineProperty(Authentication, "loginAsPublicCitizen", function (callback) {
  Authentication.login('publiccitizen', 'password', callback, false, false);
});
/**
 * Authenticate the current user with generated user account credentials in order to be able to
 * access some of the rest services.
 *
 * @param {string} username the generated username
 * @param {string} password the generated password
 * @param {function} callback a callback function that will be invoked
 * after authenticating the user. The function will receive a boolean indicating
 * success and and the response object.
 */
_defineProperty(Authentication, "loginWithGeneratedUserAccount", function (username, password, callback) {
  Authentication.login(username, password, callback, false, false);
});
/**
 * Tranform the RESTService post call into a Promise.
 *
 * @param URL the URL to be used by the post call
 * @param data the content object to be passed
 * @param type the type of data being sent
 */
_defineProperty(Authentication, "postCall", function (URL, data, type, ssoAuth, headers) {
  return new _Promise(function (resolve) {
    RESTService.post(URL, data, function (success, response) {
      resolve({
        success: success,
        response: response
      });
    }, type, ssoAuth, headers);
  });
});
/**
 * Tranform the RESTService get call into a Promise.
 *
 * @param URL the URL to be used by the get call
 * @param params the params to be passed
 * @param ssoAuth flag to indicate if SSO authentication is performed.
 * @param headers custom headers when making GET requests.
 */
_defineProperty(Authentication, "getCall", function (URL, params, ssoAuth, headers) {
  return new _Promise(function (resolve) {
    RESTService.get(URL, function (success, response) {
      resolve({
        success: success,
        response: response
      });
    }, params, ssoAuth, headers);
  });
});
/**
 * The user types in the UA application.
 */
_defineProperty(Authentication, "USER_TYPES", {
  NO_USER_TYPE: null,
  PUBLIC: 'PUBLIC',
  GENERATED: 'GENERATED',
  STANDARD: 'STANDARD',
  LINKED: 'LINKED'
});
export { Authentication as default };